import * as $ from "jquery";
var io = require("socket.io-client");

/**
 * Service to reload page upon re-connection with server.
 */
export class VersionCheck {
    private readonly VersionKey = "VersionCheck.CurrentVersion";
    private readonly url: string = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');
    private socket;

    /**
     * Starts the service.
     */
    public Start() {
        // Check the version on every websocket reconnect.
        this.socket = io.connect(this.url);
        this.socket.on("reconnect", () => {
            console.log("VersionCheck reconnected");
            $.get(this.url + "/version.txt", (serverVersion: string, status: string, jqXHR) => {
                console.log("VersionCheck data: " + serverVersion);
                // Take action only on a valid version data.
                if (serverVersion) {
                    let localVersion = this.GetVersion();
                    this.SetVersion(serverVersion);

                    console.log("VersionCheck: Reloading page");
                    window.location.reload(true);
                }
            });
        });
    }

    /**
     * Get verison from local storage.
     */
    private GetVersion(): string {
        return sessionStorage.getItem(this.VersionKey);
    }

    /**
     * Set version in the local storage.
     */
    private SetVersion(version: string) {
        sessionStorage.setItem(this.VersionKey, version);
    }
}



// WEBPACK FOOTER //
// ./src/app/service.versioncheck.ts